<template>
  <div class="box6">
    <div class="titleBox">
      <div class="title">真实学员案例</div>
      <div class="subtitle">
        学习课程后他们成功涨粉50w+<br />多条视频播放100w+
      </div>
    </div>
    <div class="subject-content">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide
          v-for="(item, index) in list"
          :key="index"
          :class="'block' + (index + 1)"
        >
          <div
            class="slide"
            :style="
              `background-image: url(` +
              require(`../../../assets/coursePage/newMedia2/box4/${
                index + 1
              }.png`) +
              `)`
            "
          >
            <!-- <div class="text-box">
              <p>
                帐号类型：

                {{ item.type }}
                <br />
                粉丝情况：

                {{ item.num }}
              </p>
            </div> -->
            <div class="seize" v-show="index == 5"></div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-pagination-box6"></div>
    </div>
      <div class="swiper-content">
        <p>按照老师的指导他们突破瓶颈<br/>
月自然流量佣金 2w+，单条广告报价8000+</p>
      <swiper
        :options="swiperOptionbox13"
        ref="mySwiperbox13"
        class="swiperitems"
      >
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in demo"
          :key="index"
        >
          <img
            :src="
              require(`../../../assets/coursePage/newMedia2/box4/0${
                index + 1
              }.png`)
            "
            alt
          />
        </swiper-slide>
      </swiper>

      <!-- <div class="swiper-pagination-box13"></div> -->
    </div>
    <div class="button" @click="openDetail">了解更多学员案例</div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import Box7 from "./Box7.vue";
import check from "../../../utils/check";
export default {
  components: {
    swiper,
    swiperSlide,
    Box7,
  },

  data() {
    return {
      list: [
        {
          type: "测评类账号",
          num: "学习课程后涨粉至20w+",
        },
        {
          type: "搞笑人设IP",
          num: "学习课程后涨粉至26w+",
        },
        {
          type: "独立剪辑师人设IP",
          num: "单月最高涨粉10w, 目前粉丝22w+",
        },
        {
          type: "口播人设IP",
          num: "单个作品发布后涨粉50w，粉丝总数68w+",
        },

        {
          type: "自用好物分享，宝藏店铺安利",
          num: "学习课程后涨粉38.5w，粉丝总数93w+",
        },
        {
          type: "美食制作分享账号",
          num: "学习课程后涨粉至4w+",
        },
      ],
      demo: [
        {
          type: "测评类账号，刚报名课程时2w+粉丝",
          num: "目前粉丝20w+，单条星图广告报价8000",
        },
        { type: "宝妈好物分享类账号", num: "目前粉丝64w+，月自然流佣金2w+" },
        { type: "宝妈好物分享类账号", num: "单日佣金可达3000+" },
        {
          type: "直播带货类账号，每天直播1小时",
          num: "目前累计带货额可达25w--50w",
        },
        {
          type: "70后美食分享类账号",
          num: "2周变现数据近10个W，小店随心推条条爆",
        },
        { type: "95后美妆分享类账号", num: "月自然佣金2600+" },
        { type: "美食家具类账号", num: "月成交订单数5w+，每月都有爆款" },
        { type: "测评类账号，月佣金1w+", num: "多平台同时运营，多渠道开花" },
      ],
      swiperOption: {
        loop: false, // 循环模式选项
        slidesPerView: "auto",
        // centeredSlides: true,
        // paginationClickable: true,
        // spaceBetween: 20,
        // effect: "left",
        pagination: {
          el: ".swiper-pagination-box6",
        },
      },
       swiperOptionbox13: {
        loop: true, // 循环模式选项
spaceBetween: 15,
       
        autoplay: false,
        centeredSlides: true,
        slidesPerView: "auto",
       
        pagination: {
          el: ".swiper-pagination-box13",
        },
      },
    };
  },
  methods: {
    openDetail() {
      if (localStorage.getItem(check.getUrlParam("subject"))) {
        window.location.href = localStorage.getItem(
          check.getUrlParam("subject")
        );
      } else {
        this.clickZiXun()
      }
      this.mai("短视频-就业课", "进入学习", 0, null);
    },
  },
};
</script>

<style lang="less" scoped>
.box6 {
  padding: 80px 0 88px;
  width: 100%;
  background: url("../../../assets/coursePage/newMedia2/box4/bgc.png") no-repeat;
  background-size: cover;
  background-position: center;
  .seize {
    width: 20px;
    background: red;
  }
  .titleBox {
    text-align: center;
    .title {
      font-size: 40px;
      font-family: PingFangSC-Semibold;
      font-weight: 500;
      color: #4d1f2e;
      line-height: 62px;
    }
    .subtitle {
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4d1f2e;
      line-height: 40px;
      margin-top: 10px;
      margin-bottom: 48px;
    }
  }
  .subject-content {
    position: relative;
    margin-top: 48px;

    width: 100%;
    box-sizing: border-box;
    .swiper-slide {
      margin-left: 32px;
      width: 382px;
	    height: 696px;
      background-size: cover;
      display: flex;

      overflow: hidden;
      position: relative;
      .slide {
       width: 382px;
	     height: 696px;
       background-size: cover;
      }
//       .text-box {
//       width: 342px;
// 	height: 169px;
// 	background-image: linear-gradient(0deg, 
// 		#ff6699 0%, 
// 		#ff3377 100%);
// 	border-radius: 14px;
//         display: flex;
//         flex-direction: column;
//         justify-content: center;
//         position: absolute;
//         bottom: 20px;
//         left: 50%;
//         transform: translateX(-50%);
// padding:  0 10px;
     

//         box-sizing: border-box;
//         p {
//           font-size: 24px;
//           font-family: PingFangSC-Medium, PingFang SC;
//           font-weight: 500;
//           color: #ffffff;
//           line-height: 40px;
//         }
//         // transform: translateY(286px);
//         opacity: 1;
//         transition: 0.5s all;
//       }
    }
    .swiper-slide:nth-child(6) {
      width: 414px;
    }
    .swiper-pagination-box6 {
      display: flex;
      align-items: center;
      position: absolute;
      left: 50%;
      margin-top: 32px;
      transform: translate(-50%, 0px);
      height: 6px;
      background: #b7a9ff;
      border-radius: 3px;
      display: none;
    }

    /deep/ .swiper-pagination-bullet {
      width: 20px;
      height: 6px;
      background: #b7a9ff;
      border-radius: 3px;
    }

    /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
      width: 20px;
      height: 6px;
      background: #775cff;
      border-radius: 3px;
    }
  }

  .button {
    width: 690px;
    height: 96px;
  background-image: linear-gradient(0deg, 
		#ff6699 0%, 
		#ff3377 100%);
    border-radius: 44px;
    margin: 60px auto 0;
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 96px;
 
    text-align: center;
  }
    .swiper-content {
    position: relative;

    margin-top: 70px;
p{
  	font-family: PingFang-SC-Medium;
	font-size: 30px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 44px;
	letter-spacing: 1px;
	color: #4d1f2e;
  margin-bottom: 45px;
  text-align: center;
}
    img {
      width: 630px;
      height: 468px;
      // background: #f5f9ff;
      border-radius: 20px;
      box-sizing: border-box;
      transition: all 0.3s;
      flex-shrink: 0;
    }

    .swiper-slide {
      display: flex;
      align-items: center;

      width: 630px;
   

      border-radius: 20px;
      box-sizing: border-box;
    }
     .swiper-slide-prev {
     margin-left: -40px;
    }
    .swiper-pagination-box13 {
      display: flex;
      align-items: center;
      position: absolute;
      left: 50%;
      bottom: 30px;
      transform: translate(-50%, 0px);
      height: 6px;
      background: #ffab9a;
      border-radius: 3px;
    }
  }
}
</style>
